import { render } from "./RecaudoView.vue?vue&type=template&id=cbb0cf1c&scoped=true"
import script from "./RecaudoView.vue?vue&type=script&lang=js"
export * from "./RecaudoView.vue?vue&type=script&lang=js"

import "./RecaudoView.vue?vue&type=style&index=0&id=cbb0cf1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb0cf1c"]])

export default __exports__